import { useRef, useState } from 'react';
import cx from 'classnames';
import { useModal, useAuthModal } from 'Hooks';
import { currentUser } from 'Utils';
import {
	UploadBox,
	PageMeta,
	ScrollBar,
	SidebarStoryHeader,
	ModalBoxUploadMedia,
	ModalBoxUploadText
} from 'Elements';
import styles from 'partials/sidebar-story-details.module.scss';

export const SidebarStoryDetails = ({
	children,
	story,
	type,
	isOpen,
	className,
	onBack
}) => {
	const osRef = useRef(null);
	const [openModalMedia, toggleModalMedia] = useModal();
	const [openModalAuth, toggleModalAuth] = useModal();
	const [modalName, setModalName] = useState('login');
	const AuthModal = useAuthModal(modalName);

	const handleModalChange = (modal_name) => {
		setModalName(modal_name);
	};

	const boxClass = cx(styles.box, className, {
		[styles.open]: isOpen,
		[styles.closing]: !isOpen
	});

	const handleToggleMedia = () => {
		if (currentUser.isLogin()) {
			toggleModalMedia();
		} else {
			toggleModalAuth();
		}
	};

	const modals = {
		image: ModalBoxUploadMedia,
		video: ModalBoxUploadMedia,
		sound: ModalBoxUploadMedia,
		text: ModalBoxUploadText
	};
	const DynamicModal = modals[type.toString()];

	return (
		<div className={boxClass}>
			<PageMeta title={story.title} />
			<ScrollBar
				ref={osRef.current}
				className={styles.scrollbar}
				options={{
					className: 'os-theme-house',
					overflowBehavior: {
						x: 'hidden'
					},
					scrollbars: {
						autoHide: 'never',
						clickScrolling: true
					}
				}}>
				<SidebarStoryHeader header={story} onBack={onBack} />
				<div className={styles.content}>{children}</div>
			</ScrollBar>
			<UploadBox
				type={type}
				className={styles.upload}
				onClick={handleToggleMedia}
			/>
			<DynamicModal
				isOpen={openModalMedia}
				onClose={handleToggleMedia}
				size="sm"
				type={type}
				storyId={story.id}
			/>
			<AuthModal
				size="sm"
				isOpen={openModalAuth}
				onClose={toggleModalAuth}
				onToggleLogin={() => handleModalChange('login')}
				onToggleForget={() => handleModalChange('forget')}
				onToggleRegister={() => handleModalChange('register')}
				onTogglePassword={() => handleModalChange('password')}
			/>
		</div>
	);
};
